import React from "react"
import "semantic-ui-css/semantic.min.css"

import BankSelector from "./BankSelector"
// import CommentFilter from "./CommentFilter"
// import DuplicateFilter from "./DuplicateFilter"
import VerificationSelector from "./VerificationSelector"

const PlusFilter = ({
  plusFilterShowMore,
  onPlusFilterPlusClick,
  onPlusFilterLessClick,
  ...logic
} = {}) => {
  return (
    <div>
      {!plusFilterShowMore ? (
        <button type="button" className="plus" onClick={onPlusFilterPlusClick}>
          More
        </button>
      ) : (
        <div className="plus-selector">
          <button type="button" className="less ui button" onClick={onPlusFilterLessClick}>
            Less
          </button>
          <div className="additional-buttons">
            <BankSelector {...logic} />
            <VerificationSelector {...logic} />
            {/* <CommentFilter {...logic} /> */}
          </div>
        </div>
      )}
    </div>
  )
}

export default PlusFilter
